import { render, staticRenderFns } from "./this_week.vue?vue&type=template&id=280c46c9"
import script from "./this_week.vue?vue&type=script&lang=js"
export * from "./this_week.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports